import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, InputModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AffectedItemsFormGroup, InvoiceErrorInternationalFormGroup } from '../../../models/cod-create.model';
import { OrderLineTableComponent } from '../../../../shared/components/order-line-table/order-line-table.component';
import { IOrderLine, ItemType } from '@cod-monorepo/interfaces';
import { InvoiceIssueTypeInternational } from '@cod-monorepo/interfaces';
import { tap } from 'rxjs';

@Component({
    selector: 'app-cod-affected-items-invoice-error-international-step',
    templateUrl: './affected-items-invoice-error-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        TextareaModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        OrderLineTableComponent
    ],
    standalone: true
})
export class CodAffectedItemsInvoiceErrorInternationalStepComponent implements OnInit {
    @Input({ required: true })
    affectedItemsForm: FormGroup<AffectedItemsFormGroup>;
    @Input({ required: true })
    form: FormGroup<InvoiceErrorInternationalFormGroup>;

    public invoiceErrorTypes = InvoiceIssueTypeInternational;
    public itemTypes = ItemType;

    ngOnInit(): void {
        this.initTypeChangeListener();
    }

    public get confirmed(): boolean {
        return this.affectedItemsForm.controls.confirmed.value ?? false;
    }

    public get lineItems(): IOrderLine[] {
        return this.affectedItemsForm.controls.affectedOrderLines.value ?? [];
    }

    public get disabled(): boolean {
        return this.affectedItemsForm.disabled;
    }

    public get valid(): boolean {
        const orderLinesSelected = (this.affectedItemsForm.controls.affectedOrderLines.value ?? []).length > 0;
        const invoiceErrorType = this.form.controls.invoiceErrorType.value;
        const invoiceErrorTypeOtherInfoDefined = !!this.form.controls.invoiceErrorTypeOtherInfo.value;

        if (invoiceErrorType === InvoiceIssueTypeInternational.OTHER) {
            return orderLinesSelected && invoiceErrorTypeOtherInfoDefined;
        }

        return orderLinesSelected && !!invoiceErrorType;
    }

    public get showOtherInvoiceErrorType(): boolean {
        return this.form.controls.invoiceErrorType.value === InvoiceIssueTypeInternational.OTHER;
    }

    public setConfirmed(): void {
        this.affectedItemsForm.controls.confirmed.setValue(true);
    }

    public handleSelectionChange(value: IOrderLine[]): void {
        this.affectedItemsForm.controls.confirmed.setValue(false);
        this.affectedItemsForm.get('affectedOrderLines')?.setValue(value);
    }

    private initTypeChangeListener(): void {
        this.form.controls.invoiceErrorType.valueChanges
            .pipe(tap(value => this.affectedItemsForm.controls.typeValid.setValue(!!value)))
            .subscribe();
    }
}
